import { render, staticRenderFns } from "./add-workflow-status-item.vue?vue&type=template&id=ccc16924&"
import script from "./add-workflow-status-item.vue?vue&type=script&lang=ts&"
export * from "./add-workflow-status-item.vue?vue&type=script&lang=ts&"
import style0 from "./add-workflow-status-item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports